// Admin — home-page collections (supabase/migrations/20261020014741_market_merchandising.sql).
// Reads the tables (admin-only by RLS); every change goes through an
// admin_market_collection_* RPC, which checks the role and re-ranks.

import { marketDb, marketRpc } from './marketDb';

const PRODUCT = 'id, title_ar, title_en, images, category, subcategory, status, review_status, seller_name_latin, price_min_cny, moq';

export async function adminCollections() {
  const { data, error } = await marketDb.from('market_collections').select('*').order('position');
  return { rows: data || [], error };
}
/** The pins (manual list / leaders) and the current ranking, with each rank's reason. */
export async function adminCollectionDetail(id) {
  const [pins, ranked] = await Promise.all([
    marketDb.from('market_collection_items').select(`position, product:market_products(${PRODUCT})`).eq('collection_id', id).order('position'),
    marketDb.from('market_collection_ranked').select(`rank, score, reason, product:market_products(${PRODUCT})`).eq('collection_id', id).order('rank').limit(48),
  ]);
  return { pins: pins.data || [], ranked: ranked.data || [], error: pins.error || ranked.error };
}
export const adminSaveCollection = (patch) => marketRpc('admin_market_collection_save', { p: patch });
export const adminDeleteCollection = (id) => marketRpc('admin_market_collection_delete', { p_id: id });
export const adminPinProduct = (collectionId, productId, position) => marketRpc('admin_market_collection_pin', { p_collection_id: collectionId, p_product_id: productId, p_position: position });
export const adminRefreshCollections = (id = null) => marketRpc('admin_market_collections_refresh', { p_collection_id: id });

export const RULES = {
  maabar_picks: ['مختارات معبر (جودة البيانات وتقييم المورد)', 'MAABAR picks (data quality, supplier rating)', { min_quality: 3 }],
  quantity_pricing: ['أسعار أفضل بالكميات (جدول أسعار المورد)', 'Better prices in volume (supplier price tiers)', { min_saving: 0.05 }],
  low_moq: ['حد أدنى منخفض للطلب', 'Low minimum order', { max_moq: 10 }],
  new_arrivals: ['أُضيفت حديثًا إلى معبر', 'New on MAABAR', { days: 30 }],
  top_rated_suppliers: ['تقييم المورد (سجل المورد نفسه)', 'Supplier rating (the supplier\'s own record)', { min_score: 4.5 }],
  maabar_best_sellers: ['الأكثر طلبًا على معبر (طلبات مدفوعة)', 'Most ordered on MAABAR (paid orders)', { days: 30, min_orders: 3 }],
};
